/* eslint-disable react-refresh/only-export-components */
export const ROUTES = {
  dashboard: '/dashboard',
  reports: '/bilans',
  expenses: '/expenses',
  suppliers: '/suppliers',
  deliveries: '/deliveries',
  containers: '/containers',
  depots: '/depots',
  categories: '/categories',
  items: '/items',
  bills: '/bills',
  customers: '/customers',
  users: '/users',
  inventory: '/inventory',
} as const

export type RouteKey = keyof typeof ROUTES

import type { LucideIcon } from 'lucide-react'
import {
  BarChart,
  LineChart,
  Home,
  Users,
  Library,
  Warehouse,
  Container,
  Receipt,
  LayoutList,
  User as UserIcon,
  Boxes,
} from 'lucide-react'

export type Role = 'OWNER' | 'ADMIN' | 'STAFF'

export type MenuItem = {
  key: RouteKey
  title: string
  link: (typeof ROUTES)[RouteKey]
  Icon: LucideIcon
  roles?: Role[]
  badgeKey?: 'cart' | 'bills' | 'deliveries'
}

export const menuItems: MenuItem[] = [
  { key: 'dashboard', title: 'Accueil', link: ROUTES.dashboard, Icon: Home },

  {
    key: 'reports',
    title: 'Bilans',
    link: ROUTES.reports,
    Icon: LineChart,
    roles: ['ADMIN', 'OWNER'],
  },
  {
    key: 'expenses',
    title: 'Dépenses',
    link: ROUTES.expenses,
    Icon: BarChart,
    roles: ['ADMIN', 'OWNER'],
  },

  {
    key: 'containers',
    title: 'Conteneurs',
    link: ROUTES.containers,
    Icon: Container,
  },
  { key: 'depots', title: 'Dépôts', link: ROUTES.depots, Icon: Warehouse },
  {
    key: 'inventory',
    title: 'Inventaire',
    link: ROUTES.inventory,
    Icon: Boxes,
    roles: ['ADMIN', 'OWNER'],
  },
  {
    key: 'categories',
    title: 'Catégories',
    link: ROUTES.categories,
    Icon: Library,
  },
  { key: 'items', title: 'Produits', link: ROUTES.items, Icon: LayoutList },
  { key: 'bills', title: 'Factures', link: ROUTES.bills, Icon: Receipt },
  {
    key: 'customers',
    title: 'Clients',
    link: ROUTES.customers,
    Icon: UserIcon,
  },
  {
    key: 'users',
    title: 'Utilisateurs',
    link: ROUTES.users,
    Icon: Users,
    roles: ['ADMIN', 'OWNER'],
  },
]
